import { render, staticRenderFns } from "./TripleButton.vue?vue&type=template&id=150c80bc&scoped=true&"
import script from "./TripleButton.vue?vue&type=script&lang=js&"
export * from "./TripleButton.vue?vue&type=script&lang=js&"
import style0 from "./TripleButton.vue?vue&type=style&index=0&id=150c80bc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c80bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
